import { createContext } from "@smartsheet/lodestar-utils";

/**
 * @deprecated This component is being removed in V6+, February 2025, in favor of the `SelectV2/MultiSelectV2` components.
 */
export const SelectAllContext = createContext({
  // Default to false so this is not enabled in single select.
  enabled: false,
  getText: () => ""
}, "SelectAllContext");
//# sourceMappingURL=SelectAllContext.js.map